import { render } from "./Datepicker.vue?vue&type=template&id=32b0fa70&ts=true"
import script from "./Datepicker.vue?vue&type=script&lang=ts"
export * from "./Datepicker.vue?vue&type=script&lang=ts"

import "./Datepicker.vue?vue&type=style&index=0&id=32b0fa70&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__